import React from 'react';
import { useTranslate } from 'react-admin';
import { Chip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { kioskAlertsLink } from './alertText';
import type { KioskAlertSummary } from './types';

export const KioskDeviceAlertsChip = ({ kioskId, summary }: { kioskId: string; summary: KioskAlertSummary | null }) => {
  const translate = useTranslate();
  const navigate = useNavigate();
  if (summary === null) return null;
  const count = kioskId in summary.byKiosk ? summary.byKiosk[kioskId] : 0;
  return (
    <Chip
      size="small"
      clickable
      color={count > 0 ? 'error' : 'default'}
      label={count > 0 ? translate('resources.kiosk-alerts.deviceChip.open', { count }) : translate('resources.kiosk-alerts.deviceChip.none')}
      data-testid={`kiosk-alerts-chip-${kioskId}`}
      onClick={(event) => {
        event.stopPropagation();
        navigate(kioskAlertsLink({ kioskId, status: 'open' }));
      }}
    />
  );
};
